import { OfferSummaryCard, createOfferSummaryCard } from '@vfde-brix/ws10/offer-summary-card';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC, Price } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enum';
import { JarvisProduct } from '../interface';
import { getOptionsPageUrl } from '../util/url';
import { formatHeadlineContent } from '../util/formatter';

const PRODUCT_NAME_FOOTNOTE = 1;

export const mountOfferSummaryCard = (id: HtmlId) =>
    createComponentById(createOfferSummaryCard, id, NO_PATTERN_BUSINESS_LOGIC);

export const updateOfferSummaryCard = (comp: OfferSummaryCard | null, product?: JarvisProduct) => {
    if (!comp || !product) {
        return;
    }

    const props = comp.getProperties();

    if (props.containerPromoPrices) {
        const [ promoPriceProps ] = props.containerPromoPrices;

        promoPriceProps.containerPromoPrice.price = Price.fromNumber(product.price.value);

        comp.updatePrices([ promoPriceProps ]);
    }

    if (props.containerButtons) {
        const [ button ] = props.containerButtons;

        button.linkHref = getOptionsPageUrl();
        button.business = NO_PATTERN_BUSINESS_LOGIC;

        comp.updateButtons([ button ]);
    }

    comp.updateHeadline({
        stdContent: formatHeadlineContent(product.name, PRODUCT_NAME_FOOTNOTE),
    });
};
